import { Button, Form, IFormRender, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { useToastDispatch } from 'contexts/ToastContext';
import { usePositionUpdate } from 'hooks';
import { useRef } from 'react';
import IPosition from 'types/Position';
import { t } from 'utils/localize';
import PositionProgressFormFields from '../components/PositionProgressFormFields';

export interface IPositionDetailsProgressFormProps {
  className?: ClassName;
  position: IPosition;
  onSubmit: (trackProgress: number) => void;
}

export interface IPositionDetailsProgressFormData {
  canTrackProgress: boolean;
  canManageProjectCostCodeQuantity: number;
}

const PositionDetailsProgressForm = (props: IPositionDetailsProgressFormProps) => {
  const { className, position, onSubmit } = props;

  const initialFormData = useRef<IPositionDetailsProgressFormData>({
    canTrackProgress: (position.canManageProjectCostCodeQuantity ?? 0) > 0,
    canManageProjectCostCodeQuantity: position.canManageProjectCostCodeQuantity ?? 0,
  });

  const [, update] = usePositionUpdate();
  const toastDispatch = useToastDispatch();

  function renderFormFields(form: IFormRender<IPositionDetailsProgressFormData>) {
    return (
      <>
        <PositionProgressFormFields form={form} />
        <Button type="primary" onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }
  async function onFormSubmit(data: IPositionDetailsProgressFormData) {
    try {
      await update({
        id: position.id,
        canManageProjectCostCodeQuantity: data.canManageProjectCostCodeQuantity,
      });
    } catch (e) {
      toastDispatch({
        type: 'OPEN',
        payload: {
          theme: Theme.DANGER,
          label: t('There was a problem updating your position. Please try again later.'),
        },
      });
    }
    onSubmit(data.canManageProjectCostCodeQuantity);
  }

  const classes = classNames('position-details-progress-form', className);

  return <Form className={classes} render={renderFormFields} onSubmit={onFormSubmit} data={initialFormData.current} />;
};

export default PositionDetailsProgressForm;
